import { Col, Row, Spin, Typography } from 'antd';
import { FC, useEffect, useState } from 'react';
import { FlexCol, Paper } from '../../components/common/common';
import { useMessageContext } from '../../state/context/MessageContext';
import { CsmBleConnectPage } from '../ConnectPage/CsmBleConnectPage';
import { CSM_PROTOCOL_COMMAND_TYPE, PERIPHERAL_ADDRESS, VERSION_INFO_ENTRIES, VersionsInfoMap, parseTextResponse, parseVersionsResponse, trimTrailingZeros } from '../../components/serial/csm';
import { v4 as uuidv4 } from 'uuid';
import { BleSpotfileManagementWidget } from '../../components/widgets/Spotfile/BleSpotfileManagementWidget';

export const CsmDevicePage: FC = () => {
  const { csmIsConnected, csmMessages, aryiotFwVersion, consumeCSMMessage, addCSMCommand } = useMessageContext();

  const [versionsInfo, setVersionsInfo] = useState<VersionsInfoMap | null>(null);
  const [deviceName, setDeviceName] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    addCSMCommand({
      id: uuidv4().toString(),
      message: {
        CmdType: CSM_PROTOCOL_COMMAND_TYPE.GetAryIOTname,
        PeripheralType: PERIPHERAL_ADDRESS.ARYIOT,
      },
    });
    addCSMCommand({
      id: uuidv4().toString(),
      message: {
        CmdType: CSM_PROTOCOL_COMMAND_TYPE.GetVersions,
      },
    });
  }, []);

  useEffect(() => {
    for (let message of csmMessages) {
      let frame = message.message;
      if (frame.PeripheralAddress === PERIPHERAL_ADDRESS.CSM && frame.Type === CSM_PROTOCOL_COMMAND_TYPE.GetVersions) {
        consumeCSMMessage(message.id);
        try {
          // TODO: response status code is encoded as ASCII
          // "1" == 0x31 (49)
          let versioninfo = parseVersionsResponse(frame.Payload.slice(1));
          setVersionsInfo(versioninfo);
          setIsLoading(false);
        } catch (e: any) {
          console.log('error parsing versions response', e.message);
        }
      } else if (frame.PeripheralAddress === PERIPHERAL_ADDRESS.ARYIOT && frame.Type === CSM_PROTOCOL_COMMAND_TYPE.GetAryIOTname) {
        let _deviceName = parseTextResponse(trimTrailingZeros(frame.Payload));
        setDeviceName(_deviceName);
      }
    }
  }, [csmMessages]);

  if (!csmIsConnected) {
    return <CsmBleConnectPage />;
  }

  return (
    <Row>
      <Col xs={24}>
        <Paper>
          <FlexCol
            style={{
              alignItems: 'center',
              justifyContent: 'center',
              gap: 3,
            }}
          >
            <Row style={{ gap: 10 }}>
              <Typography.Text
                strong
                style={{
                  fontSize: 22,
                }}
              >
                NeOse over <span style={{ color: '#0082FC' }}>BLE</span>:
              </Typography.Text>
              <Typography.Text
                strong
                style={{
                  fontSize: 22,
                }}
                editable={
                  aryiotFwVersion !== ''
                    ? {
                        maxLength: 19,
                        onChange: (value) => {
                          console.log('new deviceName is', value);
                          let stringBytes = new Uint8Array(19);
                          for (let i = 0; i < value.length; i++) {
                            stringBytes[i] = value.charCodeAt(i) & 0xff;
                          }

                          addCSMCommand({
                            id: uuidv4().toString(),
                            message: {
                              CmdType: CSM_PROTOCOL_COMMAND_TYPE.SetAryIOTname,
                              PeripheralType: PERIPHERAL_ADDRESS.ARYIOT,
                              Payload: stringBytes.slice(0, value.length),
                            },
                          });
                          setDeviceName(value);
                        },
                      }
                    : false
                }
              >
                {deviceName}
              </Typography.Text>
            </Row>
            {isLoading ? (
              <Spin />
            ) : (
              versionsInfo !== null && (
                <FlexCol
                  style={{
                    gap: 1,
                  }}
                >
                  <span key={'ARYIOT FWVERSION'}>
                    <b>ARYIOT FWVERSION:</b> {aryiotFwVersion !== '' ? aryiotFwVersion : 'Unknown'}
                  </span>

                  <span key={'CSM FWVERSION'}>
                    <b>CSM FWVERSION:</b> {versionsInfo[VERSION_INFO_ENTRIES.fwVersion]}
                  </span>
                </FlexCol>
              )
            )}
          </FlexCol>
        </Paper>
      </Col>
      <Col xs={24}>
        <BleSpotfileManagementWidget />
      </Col>
    </Row>
  );
};
